import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { documentsApi, type Document } from '../../api/documents';

export function SignatureCenterPage() {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void documentsApi.listDocuments(50).then((r) => setDocuments(r.documents)).catch((e) => setError(String(e)));
  }, []);

  const sign = async (doc: Document) => {
    try {
      await documentsApi.signDocument(doc.id, [{ name: 'Signer', email: 'signer@example.com' }]);
      const updated = await documentsApi.listDocuments(50);
      setDocuments(updated.documents);
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/documents" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Document Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Signature Center</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-3">
        {documents.map((d) => (
          <li key={d.id} className="flex items-center justify-between rounded-lg border p-4 dark:border-slate-700">
            <div>
              <span className="font-medium">{d.name}</span>
              <span className={`ml-3 rounded px-2 py-0.5 text-xs ${d.signed ? 'bg-green-100 text-green-800 dark:bg-green-900' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900'}`}>
                {d.signed ? 'Signed' : 'Pending'}
              </span>
            </div>
            {!d.signed && (
              <button onClick={() => void sign(d)} className="text-sm text-blue-600 hover:underline">Sign</button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
